export class ApiException {
  public type?: string;
  public message: string;
  public logout: boolean;
  public code?: number | string;
  public status?: number;
  public data: any;
  public name: string;
  public errors: any;

  constructor (exception: any) {
    const payload = exception?.response?.data ?? exception;
    const apiException = payload?.exception;

    this.type = apiException?.type ?? payload?.type;
    this.message = apiException?.message ?? payload?.message ?? exception?.message ?? '';
    this.logout = apiException?.logout === true || payload?.logout === true;
    this.code = apiException?.code ?? exception?.response?.status ?? exception?.code ?? payload?.code ?? payload?.statusCode;

    this.status = exception?.response?.status ?? payload?.status ?? payload?.statusCode;
    this.data = payload;
    this.name = exception?.name ?? 'ApiException';
    this.errors = payload?.errors ?? (this.message ? [this.message] : null);
  }

  get isCanceled (): boolean {
    return this.code === 'ERR_CANCELED'
      || this.name === 'CanceledError'
      || this.name === 'AbortError'
      || this.message === 'canceled'
  }

}
